import { ChangeDetectorRef, Component } from "@angular/core";
import { PanelService } from "@sharedV11/services/panel/panel.service";
import { SuperClassComponent } from "@sharedV11/super-class-edit/super-class/super-class.component";
import { EditSessionTypeComponent } from "./edit-sessiontype/edit-sessiontype.component";

@Component({
  selector: "app-sessiontype",
  templateUrl: "./sessiontype.component.html",
  styleUrls: ["./sessiontype.component.scss"],
})
export class SessionTypeComponent extends SuperClassComponent {
  constructor(
    protected panelService: PanelService,
    protected cdRef: ChangeDetectorRef
  ) {
    super(panelService, cdRef);
  }

  openPanel() {
    this.customanpanel = EditSessionTypeComponent;
    this.editChangeCss();
    this.cdRef.detectChanges();
  }
}
